import React from 'react';
import { Home } from './scenes/Home/Home';

import './App.scss';

const App: React.FC = () => {
  return (
    <div className='app'>
      <Home />
    </div>
  );
};

export default App;
